import { render, staticRenderFns } from "./vendors.vue?vue&type=template&id=6670eb0a"
import script from "./vendors.vue?vue&type=script&lang=js"
export * from "./vendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports